import React, { Component } from 'react'
import * as Sentry from '@sentry/react'
import { PermissionError } from 'src/types/errors'
import PermissionErrorReport from './permission-error-report.component'
import ErrorReport from './error-report.component'

interface Props {
  children: React.ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
  eventId: string
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null, eventId: '' }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, eventId: '' }
  }

  componentDidCatch(error: Error) {
    try {
      const eventId = Sentry.captureException(error)
      this.setState({ eventId })
    } catch (e) {
      console.error('Error handling:', e)
    }
  }

  render() {
    if (this.state.hasError && this.state.error) {
      if (this.state.error instanceof PermissionError) {
        return <PermissionErrorReport error={this.state.error} />
      }
      const errorDetail =
        this.state.error.message &&
        this.state.error.name + ' ' + this.state.error.message + ' ' + this.state.error.stack
      return <ErrorReport eventId={this.state.eventId} errorDetail={errorDetail} />
    }

    return this.props.children
  }
}
